import { app } from '../../../../../app';
import { Controller } from './integrate-fido-u2f.controller';

app.component('integrateFidoU2f', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./integrate-fido-u2f.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/integrate-fido-u2f/integrate-fido-u2f.component.js